export default __webpack_public_path__ + "static/thumbnailImage-d967d13f3c5532ccf02ba992f8dfef29.png";